import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { userService } from '@/services/UserService'
import { userKeys } from '@/hooks/queryKeys'
import type { UserListDto } from '@lib/dto/user.dto'

/** Load everyone with access to the app. */
export function useUsers(): UseQueryResult<UserListDto> {
  return useQuery({
    queryKey: userKeys.list(),
    queryFn: () => userService.list(),
    staleTime: 30_000,
  })
}
